"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var roles_json_1 = __importDefault(require("../../../roles.json"));
var VAlert_vue_1 = __importDefault(require("../scraps/VAlert.vue"));
var PermissionsGroup_vue_1 = __importDefault(require("./PermissionsGroup.vue"));
var permissions_json_1 = __importDefault(require("../../../permissions.json"));
var RoleNameInput_vue_1 = __importDefault(require("../form/RoleNameInput.vue"));
var event_bus_1 = require("../../event-bus");
exports.default = vue_1.default.extend({
    name: "edit-role",
    props: {
        rolePermissions: {
            type: Array,
            required: true
        },
        currentRole: {
            type: Object,
            required: true
        }
    },
    components: {
        PermissionsGroup: PermissionsGroup_vue_1.default,
        RoleNameInput: RoleNameInput_vue_1.default,
        VAlert: VAlert_vue_1.default
    },
    data: function () {
        return {
            roles: roles_json_1.default,
            roleName: this.currentRole.name
        };
    },
    methods: {
        permissions: function (permissionsObject) {
            if (permissionsObject === void 0) { permissionsObject = permissions_json_1.default; }
            if (typeof permissionsObject === "string") {
                return permissionsObject;
            }
            var results = [];
            for (var attr in permissionsObject) {
                if (permissionsObject.hasOwnProperty(attr)) {
                    results.push({
                        name: attr,
                        value: this.permissions(permissionsObject[attr])
                    });
                }
            }
            return results;
        },
        onRoleNameKeyDown: function (keyCode, name) {
            if (keyCode === 13) {
                event_bus_1.EventBus.$emit(event_bus_1.events.role.rename, {
                    id: this.currentRole.id,
                    name: name
                });
            }
        }
    }
});
